import React from 'react';
import PropTypes from 'prop-types';

function DropGuideArea({ offsetX = 0, offsetY = 0, width = 10, height = 10 }) {
  return (
    <div
      className="ws-drop-guide-area"
      style={{
        transform: `translate(${offsetX}px, ${offsetY}px)`,
        height,
        width,
      }}
    />
  );
}

DropGuideArea.propTypes = {
  offsetX: PropTypes.number,
  offsetY: PropTypes.number,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default DropGuideArea;
